import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getInsuranceInformationStateSelector } from '../selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IInsuranceInformationState } from '../store/insuranceInformation.types'
import { InsuranceInformationConstants } from '../store/insuranceInformation.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { setHasPatient } from '../../patientInformation/store/patientInformation.actions'

export function* saveInsuranceInformation() {
  const insuranceInformation: IInsuranceInformationState = yield select(getInsuranceInformationStateSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated = {
      ...pcrDoc,
      billing: { ...pcrDoc.billing, insuranceInformation },
    }
    try {
      yield put(setHasPatient(true))
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveInsuranceInformation() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* saveInsuranceInformationSaga() {
  yield takeLatest(
    [
      InsuranceInformationConstants.SET_ACTIVE,
      InsuranceInformationConstants.SET_GROUP_NAME,
      InsuranceInformationConstants.SET_GROUP_NUMBER,
      InsuranceInformationConstants.SET_INSURANCE_CARRIER,
      InsuranceInformationConstants.SET_POLICY,
      InsuranceInformationConstants.SET_PRIORITY,
      InsuranceInformationConstants.SET_INSURED,
      InsuranceInformationConstants.SET_INSURANCE_INFORMATION_LIST,
      InsuranceInformationConstants.SAVE_INSURANCE_INFORMATION,
    ],
    performWithMutexHOG,
    saveInsuranceInformation
  )
}
